import React from 'react';
import moment from 'moment';
import { useLocation } from 'react-router-dom';

import { logo } from '../../assets/img';
import { Typography, Button } from '../alf-design';

const Footer = ({ maxWidth = false, bgWhite = false }) => {
  const { pathname } = useLocation();
  const bgClassName =
    pathname === '/page-not-found' || bgWhite
      ? 'bg-legacy-white border-t border-legacy-borderLight'
      : 'bg-legacy-dashboardBg';

  return (
    <footer
      className={`w-full self-center p-[24px] ${maxWidth ? 'lg:px-[156.5px]' : ''} ${bgClassName}`}
      role="contentinfo"
    >
      <div>
        <Typography
          type="caption1"
          component="p"
          className="!text-legacy-textGray"
        >
          Need Help? Call Us{' '}
          <a
            data-testid="callUs"
            data-dd-action-name="footer.customer_service.call"
            href={`tel:800-748-2030`}
            className="text-legacy-primary underline"
            tabIndex="0"
          >
            (800) 748-2030
          </a>
        </Typography>
        <div className="flex flex-row gap-[12px] my-[16px]">
          <Button
            onClick={() => window.open('https://www.slideinsurance.com/')}
            id="visit-website-button"
            data-dd-action-name="footer.slide_website.open"
            type="tertiary"
          >
            Visit Slide Website
          </Button>
          <Button
            onClick={() =>
              window.open('https://www.slideinsurance.com/privacy-policy')
            }
            id="privacy-button"
            data-dd-action-name="footer.privacy_notice.open"
            type="tertiary"
          >
            Privacy Notice
          </Button>
        </div>
        <Typography
          type="footer"
          component="p"
          className="!text-legacy-textGray"
        >
          Content provided is intended for general informational purposes only.
          Any changes made to your policy may not be
          <br /> immediately reflected here. Please refer to your insurance
          policy for coverages, exclusions, and limitations.
        </Typography>
      </div>
      <div className="flex flex-col items-end">
        <img
          data-testid="logo"
          src={logo}
          width="112"
          alt="Slide Insurance logo"
          id="logo"
        />
        <Typography
          type="footer"
          component="p"
          className="!text-legacy-textGray"
        >
          {`© ${moment().format(
            'YYYY',
          )}, Slide Insurance Holdings. All rights reserved.`}
        </Typography>
      </div>
    </footer>
  );
};

export default Footer;
